var __t=window.__t=window.__t||(s=>(window.NL_I18N&&window.NL_I18N[s])||s);(() => {
  function setup(scope = document) {
    scope.querySelectorAll('[data-studio-teaser]').forEach(teaser => {
      if (teaser.dataset.ready) return;
      teaser.dataset.ready = 'true';
      const text = teaser.querySelector('[data-teaser-text]');
      const neon = teaser.querySelector('[data-teaser-neon]');
      text.addEventListener('input', () => { neon.textContent = text.value || __t("Your glow"); });
      teaser.addEventListener('click', event => {
        const light = event.target.closest('[data-teaser-light]');
        if (light) {
          const on = light.getAttribute('aria-checked') !== 'true';
          light.setAttribute('aria-checked', String(on));
          light.lastChild.textContent = on ? __t("Light on") : __t("Light off");
          teaser.classList.toggle('light-off', !on);
        }
        const colour = event.target.closest('[data-teaser-colour]');
        if (colour) {
          teaser.querySelectorAll('[data-teaser-colour]').forEach(button => button.setAttribute('aria-pressed', String(button === colour)));
          neon.style.setProperty('--neon', colour.dataset.teaserColour);
          teaser.querySelector('[data-teaser-colour-name]').textContent = colour.dataset.colourName;
        }
        const room = event.target.closest('[data-teaser-room]');
        if (room) {
          teaser.querySelectorAll('[data-teaser-room]').forEach(button => button.setAttribute('aria-pressed', String(button === room)));
          teaser.querySelectorAll('[data-scene]').forEach(scene => scene.classList.toggle('active', scene.dataset.scene === room.dataset.teaserRoom));
        }
        if (event.target.closest('[data-teaser-go]')) {
          try { sessionStorage.setItem('neonliva-studio-draft', JSON.stringify({text: text.value, colour: neon.style.getPropertyValue('--neon') || '#47ded6'})); } catch (_) { /* Navigation also works when storage is unavailable. */ }
        }
      });
    });
  }
  // Branded dropdown for selects marked data-nl-select; the native select stays the form value.
  let selectCount = 0;
  function enhanceSelect(select) {
    if (select.dataset.nlReady) return;
    select.dataset.nlReady = 'true';
    const id = `nl-select-${++selectCount}`;
    const wrap = document.createElement('div');
    wrap.className = 'nl-select';
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'nl-select-trigger field-input';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', id);
    const label = document.querySelector(`label[for="${select.id}"]`);
    if (label) { label.id = label.id || `${id}-label`; trigger.setAttribute('aria-labelledby', `${label.id} ${id}-value`); label.htmlFor = ''; label.addEventListener('click', () => trigger.focus()); }
    const value = document.createElement('span');
    value.id = `${id}-value`;
    trigger.append(value);
    const menu = document.createElement('ul');
    menu.className = 'nl-select-menu';
    menu.id = id;
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;
    const items = [...select.options].map((option, index) => {
      const item = document.createElement('li');
      item.setAttribute('role', 'option');
      item.id = `${id}-${index}`;
      item.textContent = option.textContent;
      if (option.disabled) item.setAttribute('aria-disabled', 'true');
      menu.append(item);
      return item;
    });
    let active = select.selectedIndex;
    const sync = () => {
      value.textContent = select.options[select.selectedIndex]?.textContent || '';
      items.forEach((item, index) => item.setAttribute('aria-selected', String(index === select.selectedIndex)));
    };
    const highlight = index => {
      active = index;
      items.forEach((item, i) => item.classList.toggle('active', i === index));
      trigger.setAttribute('aria-activedescendant', items[index].id);
      items[index].scrollIntoView({block: 'nearest'});
    };
    const toggle = open => {
      wrap.classList.toggle('is-open', open);
      menu.hidden = !open;
      trigger.setAttribute('aria-expanded', String(open));
      if (open) highlight(select.selectedIndex);
    };
    const choose = index => {
      if (items[index].getAttribute('aria-disabled') === 'true') return;
      toggle(false);
      trigger.focus();
      if (index === select.selectedIndex) return;
      select.selectedIndex = index;
      sync();
      select.dispatchEvent(new Event('change', {bubbles: true}));
    };
    const step = (from, dir) => {
      for (let i = from + dir; i >= 0 && i < items.length; i += dir) if (items[i].getAttribute('aria-disabled') !== 'true') return i;
      return from;
    };
    trigger.addEventListener('click', () => toggle(menu.hidden));
    menu.addEventListener('click', event => { const item = event.target.closest('[role=option]'); if (item) choose(items.indexOf(item)); });
    menu.addEventListener('mousemove', event => { const item = event.target.closest('[role=option]'); if (item) highlight(items.indexOf(item)); });
    trigger.addEventListener('keydown', event => {
      const open = !menu.hidden;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); if (!open) toggle(true); else highlight(step(active, event.key === 'ArrowDown' ? 1 : -1)); }
      else if (open && event.key === 'Home') { event.preventDefault(); highlight(step(-1, 1)); }
      else if (open && event.key === 'End') { event.preventDefault(); highlight(step(items.length, -1)); }
      else if (open && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); choose(active); }
      else if (open && (event.key === 'Escape' || event.key === 'Tab')) toggle(false);
    });
    document.addEventListener('click', event => { if (!wrap.contains(event.target)) toggle(false); });
    select.addEventListener('change', sync);
    select.hidden = true;
    select.tabIndex = -1;
    select.before(wrap);
    wrap.append(select, trigger, menu);
    sync();
  }
  function setupSelects(scope = document) { scope.querySelectorAll('select[data-nl-select]').forEach(enhanceSelect); }
  setup();
  setupSelects();
  document.addEventListener('shopify:section:load', event => { setup(event.target); setupSelects(event.target); });
})();
